<div id="analytics-container" *loading="loadStatus">
    <div class="top-bar">
        <user-search [initialValue]="search" (searchChange)="searchVisitors($event)"></user-search>
        <button mat-button (click)="exportStats()">
            <mat-icon svgIcon="download"></mat-icon>
            <span>Export</span>
        </button>
    </div>
    <table #table mat-table matSort (matSortChange)="sortData($event)" *ngIf="dataSource" [dataSource]="dataSource">

        <ng-container matColumnDef="actor_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>

          <td mat-cell *matCellDef="let visitor">
            <div class="cell-content">
                <span class="actor-name">{{ formatActor(visitor.actor_name) }}</span>
            </div> 
            </td>
        </ng-container>
        <ng-container matColumnDef="lastSessionDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Visit </th>
            <td mat-cell *matCellDef="let visitor" >
                <div class="cell-content">
                    {{ visitor.lastSessionDate | date:'medium'}} 
                </div>
            </td>
        </ng-container>
        <ng-container matColumnDef="duration">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Time spent </th>
            <td mat-cell *matCellDef="let visitor" >
                <div class="cell-content">
                    {{ visitor.duration | durationConverter:'mm' }} 
                </div>
            </td>
        </ng-container>
        <ng-container matColumnDef="sessionNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Sessions </th>
            <td mat-cell *matCellDef="let visitor">
                <div class="cell-content">
                    {{visitor.sessionNumber}} 
                </div>
            </td>
        </ng-container>
        <ng-container matColumnDef="completed" *ngIf="isCompletionEnabled()">
            <th mat-header-cell *matHeaderCellDef> Completed </th>
            <td mat-cell *matCellDef="let visitor">
                <div class="cell-content">
                    <span>{{ (visitor.completed) ? 'Completed' : 'In Progress' }}</span>
                    <mat-icon *ngIf="visitor.completed" fontSet="fa" fontIcon="fa-circle-check"></mat-icon>
                </div>
             </td>
        </ng-container>
        <ng-container matColumnDef="score" *ngIf="isScoringEnabled()">
            <th mat-header-cell *matHeaderCellDef> Score </th>
            <td mat-cell *matCellDef="let visitor">
                <div class="cell-content">
                    <span>{{ formatScore(visitor.score) }}</span>
                    <mat-icon *ngIf="visitor.completed && visitor.passed" fontSet="fa" fontIcon="fa-circle-check"></mat-icon>
                    <mat-icon *ngIf="visitor.completed && !visitor.passed" fontSet="fa" fontIcon="fa-circle-xmark"></mat-icon>
                </div>
            </td>
        </ng-container>
        <ng-container matColumnDef="linkQuiz" *ngIf="isQuizzEnabled()">
            <th mat-header-cell *matHeaderCellDef> </th>
            <td mat-cell *matCellDef="let visitor"> 
                <div class="cell-content">
                    <span class="link" (click)="onSeeQuizResultClick(visitor.actor_name)">Quiz Results</span>
                </div>
            </td>
        </ng-container>
        <ng-container matColumnDef="linkSessions">
            <th mat-header-cell *matHeaderCellDef> </th>
            <td mat-cell *matCellDef="let visitor"> 
                <div class="cell-content">
                    <span class="link" (click)="onSeeSessionsClick(visitor.actor_name)">Sessions Logs</span> 
                </div>
            </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <div *ngIf="noData" class="nodata"> No data available </div>
  </div>

